import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { ulGtpDataVolumeNrChartConfig } from '../chartConfigs';

/**
 * Props for the UlGtpDataVolumeNrEcharts component
 */
interface UlGtpDataVolumeNrEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Uplink GTP Data Volume Chart (NR Site Level)
 * 
 * Displays uplink S1-U GTP Tunneling Protocol data volume in GB for NR sites.
 * Tracks total uplink throughput across all cells for capacity planning and monitoring.
 * 
 * @component
 * @example
 * ```tsx
 * <UlGtpDataVolumeNrEcharts onFullscreenToggle={handleFullscreen} isFullscreen={false} />
 * ```
 * 
 * @see {@link ../chartConfigs.ts} - Chart configuration (ulGtpDataVolumeNrChartConfig)
 * @see {@link ../../../components/SiteCharts/SiteCharts.tsx} - Template component
 * @see API: /api/nr/ul-gtp-data-volume?site_name={siteName}
 */
const UlGtpDataVolumeNrEcharts: React.FC<UlGtpDataVolumeNrEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={ulGtpDataVolumeNrChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default UlGtpDataVolumeNrEcharts;
